import { render, staticRenderFns } from "./LogisticsCompany.vue?vue&type=template&id=600686a1&scoped=true"
import script from "./LogisticsCompany.vue?vue&type=script&lang=js"
export * from "./LogisticsCompany.vue?vue&type=script&lang=js"
import style0 from "./LogisticsCompany.vue?vue&type=style&index=0&id=600686a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600686a1",
  null
  
)

export default component.exports